import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import { PopupBoxClose, PopupButtons, PopupContent, PopupHeader } from './styles';
import { LightDiskButton } from '../common/fromAuth/LightDiskButton/LightDiskButton';

const PromoSimplePopup = ({ popupRef = null, ...props }) => {
    useEffect(() => {
        return () => {
            if (props.onPopupClose) {
                props.onPopupClose();
            }
        };
    }, []);

    return (
        <>
            {!props.withoutCloseButton && (
                <PopupBoxClose>
                    <LightDiskButton
                        onClick={() => {
                            if (props.handleClose) {
                                props.handleClose();
                            } else {
                                popupRef.current?.close();
                            }
                        }}
                        iconName="cross"
                        iconColor="secondary"
                        size="small"
                        type="button"
                        variant="tertiary"
                        raised={false}
                    />
                </PopupBoxClose>
            )}
            <PopupContent>
                {props.text && <PopupHeader textAlign={props.textAlign}>{props.text}</PopupHeader>}
                <PopupButtons withoutBorder={props.withoutBorder}>{props.children}</PopupButtons>
            </PopupContent>
        </>
    );
};
PromoSimplePopup.propTypes = {
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    withoutCloseButton: PropTypes.bool,
    withoutBorder: PropTypes.bool,
    textAlign: PropTypes.string,
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    handleClose: PropTypes.func,
    onPopupClose: PropTypes.func,
    children: PropTypes.node,
};

export default PromoSimplePopup;
